// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPrefundSummaryDto
 */
export interface IPrefundSummaryDto {
    /**
     * 
     * @type {number}
     * @memberof IPrefundSummaryDto
     */
    prefund_history_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IPrefundSummaryDto
     */
    calculated_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IPrefundSummaryDto
     */
    current_prefund_holding?: number;
    /**
     * 
     * @type {string}
     * @memberof IPrefundSummaryDto
     */
    date_last_fund_received?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IPrefundSummaryDto
     */
    retries_exceeded?: boolean;
    /**
     * 
     * @type {number}
     * @memberof IPrefundSummaryDto
     */
    organization_id?: number;
}

/**
 * Check if a given object implements the IPrefundSummaryDto interface.
 */
export function instanceOfIPrefundSummaryDto(value: object): value is IPrefundSummaryDto {
    return true;
}

export function IPrefundSummaryDtoFromJSON(json: any): IPrefundSummaryDto {
    return IPrefundSummaryDtoFromJSONTyped(json, false);
}

export function IPrefundSummaryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPrefundSummaryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'prefund_history_id': json['prefund_history_id'] == null ? undefined : json['prefund_history_id'],
        'calculated_amount': json['calculated_amount'] == null ? undefined : json['calculated_amount'],
        'current_prefund_holding': json['current_prefund_holding'] == null ? undefined : json['current_prefund_holding'],
        'date_last_fund_received': json['date_last_fund_received'] == null ? undefined : json['date_last_fund_received'],
        'retries_exceeded': json['retries_exceeded'] == null ? undefined : json['retries_exceeded'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
    };
}

export function IPrefundSummaryDtoToJSON(json: any): IPrefundSummaryDto {
    return IPrefundSummaryDtoToJSONTyped(json, false);
}

export function IPrefundSummaryDtoToJSONTyped(value?: IPrefundSummaryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'prefund_history_id': value['prefund_history_id'],
        'calculated_amount': value['calculated_amount'],
        'current_prefund_holding': value['current_prefund_holding'],
        'date_last_fund_received': value['date_last_fund_received'],
        'retries_exceeded': value['retries_exceeded'],
        'organization_id': value['organization_id'],
    };
}

